import type { WaveData } from '../types';

/** Legacy records without a status predate provenance metadata and remain usable. */
export const hasMarineData = (waves: WaveData): boolean =>
  waves.dataStatus !== 'unavailable' && Number.isFinite(waves.height);

export const marineCoverageDays = <T extends { waves: WaveData }>(forecasts: T[]): number =>
  forecasts.filter(forecast => hasMarineData(forecast.waves)).length;

export const formatWaveHeight = (waves: WaveData, spacing = true): string =>
  hasMarineData(waves) ? `${waves.height}${spacing ? ' ' : ''}ft` : '—';

export const formatWavePeriod = (waves: WaveData, spacing = true): string =>
  hasMarineData(waves) && Number.isFinite(waves.period) && waves.period > 0
    ? `${waves.period}${spacing ? ' ' : ''}s`
    : '—';
